import axios from 'axios'
import router from '@/router'
import { Dialog } from 'vant'
import store from '../store'
import api from '../interface/index'
const request = axios.create({
  // baseURL: 'https://yinji.gaoshan.co/api/',
  baseURL: api.commonUrl + '/api',
  timeout: 60000
})

request.interceptors.request.use(function (config) {
  let token = localStorage.getItem('yinjiToken')
  let companyId = localStorage.getItem('companyId')
  if (token) {
    config.headers['Authorization'] = token
  }
  if (companyId) {
    config.headers['company-id'] = companyId
  }
  return config
}, function (err) {
  return Promise.reject(err)
})

request.interceptors.response.use(function (response) {
  if (response.data.code === 200) {
    return response.data
  } else {
    if (response.data.message) {
      Dialog.alert({
        message: response.data.message
      })
    }
    if (response.data.code === 401) {
      Promise.reject(new Error(response))
      store.commit('setUser', null)
      localStorage.clear()
      router.push({
        path: '/login'
      })
    } else {
      return Promise.reject(response.data)
    }
  }
}, function (err) {
  return Promise.reject(err)
})

export default request
